import React, { useState, useEffect, forwardRef } from 'react';

import activ from '../assets/4530318_19305 1 (2).svg';
import indigo from '../assets/indigo-svgrepo-com 1.svg';
import yes from '../assets/Vector 138.png';
import no from '../assets/maki_cross.png';
import pln1 from '../assets/Group 1618874036.png';
import pln2 from '../assets/Group 1618874037.png';
import fyi from '../assets/Group 1008.svg';
import clock1 from '../assets/cil_clock (1).png';
import clock2 from '../assets/cil_clock.png';
import group1082 from '../assets/Group 1082.png';
import vector from '../assets/Vector (2).png';
import family from '../assets/family-svgrepo-com (1).png';
import screenshot from '../assets/Screenshot 2024-08-21 031108 1.png';
import refund from '../assets/refund-svgrepo-com.png';
import travel1 from '../assets/travel-svgrepo-com (1).svg';
import travel2 from '../assets/travel-svgrepo-com.svg';
import bigarrow from '../assets/Arrow 1.png';
import hotel1 from '../assets/Rectangle 439.svg';
import hoteltransfer from '../assets/hotel transfer new.svg';
import dwactiv from '../assets/Vector (1) 2.svg';

import BASE_URL from '../config';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faStarHalfAlt, faStar as faStarEmpty } from '@fortawesome/free-solid-svg-icons';

import '../styles/DayWisePlan.css';

const DayWisePlan = forwardRef((props, ref) => {
  const [plans, setPlans] = useState([]);
  const [activeDay, setActiveDay] = useState(0);
  const [showCustomizeForm, setShowCustomizeForm] = useState(false);
  const [showCustomizeFlight, setShowCustomizeFlight] = useState(false);

  // Track selected flight for the current day
  const [selectedFlightIndex, setSelectedFlightIndex] = useState(0);
  const [flightSort, setFlightSort] = useState("");
  const [flightFilter, setFlightFilter] = useState("");

  const handleCloseGallery = () => {
    setShowCustomizeFlight(prev => !prev);
  };
  // Place this at the top of your file, after your imports

  const mockData = [
    {
      day: '1',
      date: '28 Oct, Mon',
      travel: {
        date: '21st October',
        from: 'Bengaluru',
        fromcode: 'BLR',
        fromair: 'Kempegowda Terminal 1',
        to: 'Malaysia',
        tocode: 'MLR',
        toair: 'Birsa Munda Terminal 1',
        airline: 'Air Asia',
        airlineClass: 'Economy',
        departureTime: '12:10 PM',
        arrivalTime: '14:40 PM',
        duration: '5h 30m',
        class: 'Economy',
        refundable : 'Refundable',
        icon: indigo,
        pnr:'6E-0876',
        carryon: '15kg',
        checkin: '7kg',
      },
      hotels: [
        {
          id: 1,
          name: '1N in Maldives @ Adaaran Select Hudhuran Fushi',
          imgUrl: { hotel1 },
          rating: '4.5',
          amenities: [
            { name: 'Private Pool', available: 'Yes' },
            { name: 'Wifi', available: 'Yes' },
            { name: 'Spa', available: 'No' },
            { name: 'Butler Service', available: 'Yes' },
            { name: 'Laundry Service', available: 'Yes' },
            { name: 'Food Service', available: 'Yes' }
          ],
          checkIn: '11:00 AM',
          checkOut: '10:00 AM',
          people: '2 Adults',
          rooms: '1',
          area: '1000 sq.ft',
          bookingDate: '22nd October',
        },
      ],
      activities: [
        {
          time: 'Full Day',
          activity: 'Islamic Arts Museum Malaysia',
          description: 'A rich collection of Islamic decorative arts including pottery, sculptures, and paintings.',
        },
      ],
    },
    {
      day: '2',
      date: '29 Oct, Tue',
      travel: {
        date: '22nd October',
        from: 'Malaysia',
        to: 'Singapore',
        airline: 'Singapore Airlines',
        airlineClass: 'Business',
        departureTime: '09:00 AM',
        arrivalTime: '10:30 AM',
        duration: '1h 30m',
      },
      hotels: [
        {
          id: 2,
          name: '1N in Singapore @ Marina Bay Sands',
          imgUrl: '/src/assets/Rectangle 440.svg',
          rating: '5.0',
          amenities: ['Infinity Pool', 'Wifi', 'Gym', 'Spa'],
          checkIn: '02:00 PM',
          checkOut: '12:00 PM',
          people: '2 Adults',
          rooms: '1',
          area: '1200 sq.ft',
          bookingDate: '23rd October',
        },
      ],
      activities: [
        {
          time: 'Evening',
          activity: 'Gardens by the Bay',
          description: 'Explore the beautiful gardens, the Flower Dome, and Cloud Forest.',
        },
      ],
    },
    {
      day: '3',
      date: '30 Oct, Wed',
      travel: {
        date: '23rd October',
        from: 'Singapore',
        to: 'Bangkok',
        airline: 'Thai Airways',
        airlineClass: 'Economy',
        departureTime: '11:00 AM',
        arrivalTime: '12:30 PM',
        duration: '2h 30m',
      },
      hotels: [
        {
          id: 3,
          name: '2N in Bangkok @ The Siam Hotel',
          imgUrl: '/src/assets/Rectangle 441.svg',
          rating: '4.8',
          amenities: ['Pool', 'Wifi', 'Airport Shuttle', 'Breakfast Included'],
          checkIn: '03:00 PM',
          checkOut: '11:00 AM',
          people: '2 Adults',
          rooms: '1',
          area: '1500 sq.ft',
          bookingDate: '24th October',
          amenities:[
            {
              wifi:'yes',
              lift:'yes',
            }
          ]
        },
      ],
      activities: [
        {
          time: 'Morning',
          activity: 'Grand Palace',
          description: 'A historical palace complex with temples and museums.',
        },
      ],
    },
    {
      day: '4',
      date: '31 Oct, Thu',
      travel: {
        date: '24th October',
        from: 'Bangkok',
        to: 'Phuket',
        airline: 'Bangkok Airways',
        airlineClass: 'Economy',
        departureTime: '08:30 AM',
        arrivalTime: '10:00 AM',
        duration: '1h 30m',
      },
      hotels: [
        {
          id: 4,
          name: '3N in Phuket @ Keemala Resort',
          imgUrl: '/src/assets/Rectangle 442.svg',
          rating: '4.9',
            amenities: [
              { name: 'Private Pool', available: 'Yes' },
              { name: 'Wifi', available: 'Yes' },
              { name: 'Spa', available: 'No' },
              { name: 'Butler Service', available: 'Yes' }
            ],
          checkIn: '01:00 PM',
          checkOut: '11:00 AM',
          people: '2 Adults',
          rooms: '1',
          area: '1800 sq.ft',
          bookingDate: '25th October',
        },
      ],
      activities: [
        {
          time: 'Afternoon',
          activity: 'Phi Phi Islands Tour',
          description: 'Snorkeling, beach activities, and island exploration.',
        },
      ],
    },
    {
      day: '5',
      date: '1 Nov, Fri',
      travel: {
        date: '25th October',
        from: 'Phuket',
        to: 'Bengaluru',
        airline: 'Air Asia',
        airlineClass: 'Economy',
        departureTime: '06:00 PM',
        arrivalTime: '08:30 PM',
        duration: '4h 30m',
      },
      hotels: [],
      activities: [
        {
          time: 'Morning',
          activity: 'Relax at the Beach',
          description: 'Enjoy the beach and prepare for the journey back.',
        },
      ],
    },
];

  // Mock flight data for each day (for demo, use same for all days)
  const flightMockData = [
    {
      totalPrice: 12500,
      travel: {
        date: '21st October',
        from: 'Bengaluru',
        fromcode: 'BLR',
        fromair: 'Kempegowda Terminal 1',
        to: 'Malaysia',
        tocode: 'MLR',
        toair: 'Birsa Munda Terminal 1',
        airline: 'Air Asia',
        airlineClass: 'Economy',
        departureTime: '12:10 PM',
        arrivalTime: '14:40 PM',
        duration: '5h 30m',
        class: 'Economy',
        refundable: 'Refundable',
        icon: indigo,
        pnr: '6E-0876',
        carryon: '15kg',
        checkin: '7kg',
      }
    },
    {
      totalPrice: 18900,
      travel: {
        date: '22nd October',
        from: 'Malaysia',
        fromcode: 'MLR',
        fromair: 'Birsa Munda Terminal 1',
        to: 'Singapore',
        tocode: 'SIN',
        toair: 'Changi Terminal 3',
        airline: 'Singapore Airlines',
        airlineClass: 'Business',
        departureTime: '09:00 AM',
        arrivalTime: '10:30 AM',
        duration: '1h 30m',
        class: 'Business',
        refundable: 'Refundable',
        icon: indigo,
        pnr: 'SQ-425',
        carryon: '20kg',
        checkin: '10kg',
      }
    },
    {
      flightId: 'FLIGHT003',
      totalPrice: 9900,
      travel: {
        date: '23rd October',
        from: 'Singapore',
        fromcode: 'SIN',
        fromair: 'Changi Terminal 3',
        to: 'Bangkok',
        tocode: 'BKK',
        toair: 'Suvarnabhumi Terminal 1',
        airline: 'Thai Airways',
        airlineClass: 'Economy',
        departureTime: '11:00 AM',
        arrivalTime: '12:30 PM',
        duration: '2h 30m',
        class: 'Economy',
        refundable: 'Non-Refundable',
        icon: indigo,
        pnr: 'TG-402',
        carryon: '15kg',
        checkin: '7kg',
      }
    },
    {
      totalPrice: 7800,
      travel: {
        date: '24th October',
        from: 'Bangkok',
        fromcode: 'BKK',
        fromair: 'Suvarnabhumi Terminal 1',
        to: 'Phuket',
        tocode: 'HKT',
        toair: 'Phuket International',
        airline: 'Bangkok Airways',
        airlineClass: 'Economy',
        departureTime: '08:30 AM',
        arrivalTime: '10:00 AM',
        duration: '1h 30m',
        class: 'Economy',
        refundable: 'Refundable',
        icon: indigo,
        pnr: 'PG-273',
        carryon: '10kg',
        checkin: '5kg',
      }
    },
  ];

   const fetchItinerary = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/user_tour/itinerary`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching itinerary:', error);
      throw error;
    }
  };

  const fetchSupportedActivities = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/supported_activity`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching supported activities:', error);
      throw error;
    }
  };

  const fetchSupportedHotels = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/supported_hotel`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching supported hotels:', error);
      throw error;
    }
  };

  const fetchSupportedFlights = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/supported_flight`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching supported flights:', error);
      throw error;
    }
  };


  // Sorting and filtering logic for flights
  const getSortedFlights = () => {
    let flights = [...flightMockData];

    // Filtering
    if (flightFilter === "refundable") {
      flights = flights.filter(f => f.travel.refundable === "Refundable");
    } else if (flightFilter === "non-refundable") {
      flights = flights.filter(f => f.travel.refundable === "Non-Refundable");
    } else if (flightFilter === "economy") {
      flights = flights.filter(f => f.travel.class === "Economy");
    } else if (flightFilter === "business") {
      flights = flights.filter(f => f.travel.class === "Business");
    }
    // Add more filter options as needed

    // Sorting
    if (flightSort === "price-low-high") {
      flights.sort((a, b) => a.totalPrice - b.totalPrice);
    } else if (flightSort === "price-high-low") {
      flights.sort((a, b) => b.totalPrice - a.totalPrice);
    } else if (flightSort === "duration") {
      const parseDuration = d => {
        const match = d.match(/(\d+)h\s*(\d+)?m?/);
        if (!match) return 0;
        return parseInt(match[1] || 0) * 60 + parseInt(match[2] || 0);
      };
      flights.sort((a, b) => parseDuration(a.travel.duration) - parseDuration(b.travel.duration));
    } else if (flightSort === "departure") {
      const parseTime = t => {
        const [time, meridian] = t.split(" ");
        let [h, m] = time.split(":").map(Number);
        if (meridian === "PM" && h !== 12) h += 12;
        if (meridian === "AM" && h === 12) h = 0;
        return h * 60 + m;
      };
      flights.sort((a, b) => parseTime(a.travel.departureTime) - parseTime(b.travel.departureTime));
    } else if (flightSort === "arrival") {
      const parseTime = t => {
        const [time, meridian] = t.split(" ");
        let [h, m] = time.split(":").map(Number);
        if (meridian === "PM" && h !== 12) h += 12;
        if (meridian === "AM" && h === 12) h = 0;
        return h * 60 + m;
      };
      flights.sort((a, b) => parseTime(a.travel.arrivalTime) - parseTime(b.travel.arrivalTime));
    }

    return flights;
  };

  // Update the selected flight in the plan for the current day
  const handleSelectFlight = (flightIdx, sortedFlights) => {
    // Find the original index in flightMockData
    const selectedFlight = sortedFlights[flightIdx];
    const originalIdx = flightMockData.findIndex(f =>
      f.travel.pnr === selectedFlight.travel.pnr
    );
    setSelectedFlightIndex(originalIdx);
    setPlans(prevPlans => {
      const updatedPlans = [...prevPlans];
      if (updatedPlans[activeDay]) {
        updatedPlans[activeDay] = {
          ...updatedPlans[activeDay],
          travel: { ...selectedFlight.travel }
        };
      }
      return updatedPlans;
    });
    setShowCustomizeFlight(false);
  };

  useEffect(() => {
    setPlans(mockData);
  }, []);

  return (
    <div style={{backgroundColor:'#FBF4FF', borderRadius:'30px', border:'solid 2px #541C9C' , margin: '20px'  }}>
      <div className='overview-title'>Daywise Plan</div>
      <div className="day-wise-plan-container" ref={ref} id="dayWisePlan">
        <DayNavigation plans={plans} activeDay={activeDay} setActiveDay={setActiveDay} />
        {plans[activeDay] && (
          <DayPlan 
            plan={plans[activeDay]} 
            toggleFlightForm={() => setShowCustomizeFlight(prev => !prev)} 
            toggleForm={() => setShowCustomizeForm(prev => !prev)} 
          />
        )}
        {showCustomizeForm && <FilterHotel onClose={() => setShowCustomizeForm(false)} />}
        {showCustomizeFlight && (
          <FilterFlight
            onClose={handleCloseGallery}
            flightMockData={getSortedFlights()}
            selectedFlightIndex={selectedFlightIndex}
            onSelectFlight={handleSelectFlight}
            setFlightSort={setFlightSort}
            setFlightFilter={setFlightFilter}
            flightSort={flightSort}
            flightFilter={flightFilter}
          />
        )}
      </div>
    </div>
  );
});

const DayNavigation = ({ plans, activeDay, setActiveDay }) => {
  return (
    <div className="day-plan-navigation">
      {plans.map((plan, index) => (
        <div key={index} className='date-dw-plan'>
          <div
            className={`day-plan-nav-item ${index === activeDay ? 'active' : ''}`}
            onClick={() => setActiveDay(index)}
          >
            {plan.date}
          </div>
          {index < plans.length - 1 && <div className="blue-vertical-line"></div>}
        </div>
      ))}
    </div>
  );
};

const DayPlan = ({ plan, toggleForm,toggleFlightForm  }) => {
  return (
    <div className="day-plan">
      <div className="day-title">Day - {plan.day}</div>
      
      {plan.travel && (
        <div className="travel-section">
          <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
            <h3>{plan.travel.from} → {plan.travel.to}</h3>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',gap:'30px'}}>
              <div style={{marginRight:'15px'}}><img src={refund}/>{plan.travel.refundable}</div>
              <div><img src={screenshot}/>{plan.travel.class}</div>
            </div>
            <button className="customize-btn" onClick={toggleFlightForm}>Customize</button>
          </div>
          <div style={{fontWeight:'600',color:'#2F80ED'}}>{plan.travel.date}</div>
          <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'90%'}}>
              
              <div style={{display:'flex',flexDirection:'row'}}>
              <div ><img src={plan.travel.icon} style={{width:'70px',height:'auto'}}></img></div>
              <div>
                  <div>{plan.travel.airline}</div>
                  <div style={{color:'#777777'}}>{plan.travel.pnr}</div>
                  <div style={{color:'#777777',fontWeight:'300',fontSize:'12px'}}><img style={{width:'20px'}} src={travel2}/>{plan.travel.carryon} Check In</div>
                  <div style={{color:'#777777',fontWeight:'300',fontSize:'12px'}}><img style={{width:'20px'}} src={travel1}/>{plan.travel.checkin} Carry On</div>
              </div>
              </div>
              <div>
                  <div style={{fontWeight:'600'}}>{plan.travel.departureTime},{plan.travel.date}</div>
                  <div style={{fontWeight:'400'}}>{plan.travel.from}-{plan.travel.fromcode}</div>
                  <div style={{fontWeight:'300'}}>{plan.travel.fromair}</div>
              </div>
              <div>
              <div style={{textAlign:'center'}}>{plan.travel.duration}</div>
              <div style={{display:'flex',flexDirection:'row'}}>
                <div ><img src={pln1} style={{width:'30px',height:'auto'}}/></div>
                <div className='blue-line'></div>
                <div ><img src={pln2} style={{width:'30px',height:'auto'}}/></div>
              </div>
              <div style={{textAlign:'center'}}>Non-stop</div>
              </div>
              <div>
              <div>
                  <div style={{fontWeight:'600'}}>{plan.travel.arrivalTime},{plan.travel.date}</div>
                  <div style={{fontWeight:'400'}}>{plan.travel.to}-{plan.travel.tocode}</div>
                  <div style={{fontWeight:'300'}}>{plan.travel.toair}</div>
              </div>
              </div>
          </div>
        </div>
      )}
      
      {plan.hotels && plan.hotels.length > 0 && (
        <div>
          <div style={{display:'flex'}}><img src={hoteltransfer} style={{width:'300px',margin:'0 auto'}}></img></div>
          <div className="hotel-section">
            <div className="hotel-info">
              
              <div className="hotel-header">
                <h4 >{plan.hotels[0].name}</h4>
                <button className="customize-btn" onClick={toggleForm}>Customize</button>
              </div>
              <div style={{color:'#2F80ED',fontWeight:'600'}}>{plan.hotels[0].bookingDate}</div>
            </div>
          
            <div className="hotel-details" style={{ display: 'flex', flexDirection: 'row', borderTop: 'solid 1px',borderBottom: 'solid 1px'}}>
              <div className="hotel-image-dyp">
                <img src={hotel1} alt="Hotel" />
              </div>
              <div className="hotel-meta">
                <div className="hotel-rating">
                  <div>Rating: {plan.hotels[0].rating}</div>
                  <div><StarRating rating={parseFloat(plan.hotels[0].rating)} /> </div>
                  <div>Refundable </div>
                </div>
                <ul className="room-detail">
                  <li><img src={group1082}/> Guests: {plan.hotels[0].people}</li>
                  <li><img src={vector}/> Rooms: {plan.hotels[0].rooms}</li>
                  <li><img src={family}/> Area: {plan.hotels[0].area}</li>
                </ul>
                <div className='checkin'>
                <div> <img src={clock1}/> Check-in: {plan.hotels[0].checkIn}</div>
                <div><img src={clock2}/> Check-out: {plan.hotels[0].checkOut}</div>
                </div>
                <div className='day-wise-line'></div>
                <ul className="amenities">
                  {plan.hotels[0].amenities.map((amenity, idx) => (
                    <li key={idx} style={{ display: 'flex', alignItems: 'center' }}>
                      {amenity.available === 'Yes' ? (
                        <img src={yes} alt="Available" style={{ height: '20px', marginRight: '5px' }} />
                      ) : (
                        <img src={no} alt="Not Available" style={{ height: '20px', marginRight: '5px' }} />
                      )}
                      {amenity.name}
                    </li>
                   ))}
                </ul>
              </div>
            </div>
            
            <div style={{display:'flex',flexDirection:'row',padding:'10px'}}>
              <img src={fyi} style={{width:'30px',height:'30px',}}/>
              <ul style={{ fontSize: 'large' }} className='hotellistinfo'>
                <li style={{fontSize:'small'}}> <span class="bullet-dot"></span> Hotels may charge a caution deposit on your credit card.</li>
                <li style={{fontSize:'small'}}><span class="bullet-dot"></span> It will be refunded within 10-15 days if there is no property damage. The Adaaran Select Hudhuran Fushi in Maldives does not have an elevator.</li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {plan.activities && plan.activities.length > 0 && (
        <div className="activities-section">
          <h4><img style={{width:'30px'}} src={dwactiv}></img>  Activities</h4>
          {plan.activities.map((activity, idx) => (
            <div key={idx} className="activity">
              <div className='dp-table'>
                <div className="dp-grid">
                  <div className="time-slot morning">MORNING</div>
                  <div className="time-slot afternoon">AFTERNOON</div>
                  <div className="time-slot evening">EVENING</div>
                  <div className="time-slot night">NIGHT</div>

                  <div className="activity-slot morning-slot">
                    <ActivityCell activity={{ type: "ACTIVITY", detail: { name: activity.time === "Morning" ? activity.activity : "" } }} />
                  </div>
                  <div className="activity-slot afternoon-slot">
                    <ActivityCell activity={{ type: "ACTIVITY", detail: { name: activity.time === "Afternoon" ? activity.activity : "" } }} />
                  </div>
                  <div className="activity-slot evening-slot">
                    <ActivityCell activity={{ type: "ACTIVITY", detail: { name: activity.time === "Evening" ? activity.activity : "" } }} />
                  </div>
                  <div className="activity-slot night-slot">
                    <ActivityCell activity={{ type: "ACTIVITY", detail: { name: activity.time === "Night" ? activity.activity : "" } }} />
                  </div>
                </div>
              </div>
              <img src={activ} alt="Activity Icon" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const StarRating = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 !== 0;
  const emptyStars = 5 - Math.ceil(rating);

  return (
    <div className="star-rating">
      {Array(fullStars).fill().map((_, index) => (
        <FontAwesomeIcon key={index} icon={faStar} style={{ color: 'gold' }} />
      ))}
      {halfStar && <FontAwesomeIcon icon={faStarHalfAlt} style={{ color: 'gold' }} />}
      {Array(emptyStars).fill().map((_, index) => (
        <FontAwesomeIcon key={index} icon={faStarEmpty} style={{ color: 'gold' }} />
      ))}
    </div>
  );
};



const FilterFlight = ({
  onClose,
  flightMockData,
  selectedFlightIndex,
  onSelectFlight,
  setFlightSort,
  setFlightFilter,
  flightSort,
  flightFilter
}) => {
  // Assume the first flight is the currently selected one for comparison
  const currentFlightPrice = flightMockData[selectedFlightIndex]?.totalPrice || 0;

  return (
    <div className="flight-filter-modal">
      <div>
        <div className="flight-filter-header">
          <div>Change Flight</div>
          <div style={{ cursor: "pointer" }} onClick={onClose}>X</div>
        </div>
        
        <div className='flight-place-names'>
          <div style={{gap: '8px', fontWeight: '700', fontSize: '23px'}}>
            From <span><img src={bigarrow} alt="arrow" /></span> To
          </div>
          <div className='flight-places-fliters'>
            <select
              className="visa-type-select"
              value={flightSort}
              onChange={e => setFlightSort(e.target.value)}
            >
              <option value="">Sort by</option>
              <option value="price-low-high">Price: Low to High</option>
              <option value="price-high-low">Price: High to Low</option>
              <option value="duration">Duration</option>
              <option value="departure">Departure Time</option>
              <option value="arrival">Arrival Time</option>
            </select>
            <select
              className="visa-type-select"
              value={flightFilter}
              onChange={e => setFlightFilter(e.target.value)}
            >
              <option value="">Filter</option>
              <option value="refundable">Refundable</option>
              <option value="non-refundable">Non-Refundable</option>
              <option value="economy">Economy</option>
              <option value="business">Business</option>
              <option value="airline">Airline</option>
            </select>
          </div>
        </div>
        <div style={{padding: '30px'}}>
          {flightMockData.map((plan, index) => {
            // Calculate price difference
            const diff = plan.totalPrice - currentFlightPrice;
            let diffText = '';
            let diffColor = '';
            if (diff > 0) {
              diffText = `+${diff}`;
              diffColor = 'green';
            } else if (diff < 0) {
              diffText = `${diff}`;
              diffColor = 'red';
            } else {
              diffText = '0';
              diffColor = 'black';
            }
            return (
              <div
                key={index}
                style={{
                  border: '1px solid #541c9c',
                  borderRadius: '8px',
                  marginBottom: '30px',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center',borderBottom: '1px solid #541c9c'}}>
                  <input
                    type="radio"
                    name="selectedFlight"
                    checked={plan.travel.pnr === flightMockData[selectedFlightIndex]?.travel.pnr}
                    onChange={() => onSelectFlight(index, flightMockData)}
                    style={{
                      width: '22px',
                      height: '22px',
                      marginLeft: '10px',
                      backgroundColor: '#ffffff',
                      border: '3px solid #321E5D',
                      borderRadius: '50%',
                      accentColor: '#321E5D',
                      display: 'inline-block',
                      position: 'relative',
                    }}
                  />
                  <div style={{color: diffColor, fontWeight: 600, fontSize: '24px', padding: '10px', minWidth: '70px', textAlign: 'center'}}>
                    {diffText}
                  </div>
                </div>
                <div style={{padding:'10px', flex: 1}}>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}>
                    <h3>{plan.travel.from} → {plan.travel.to}</h3>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      gap: '30px'
                    }}>
                      <div style={{marginRight: '15px'}}>
                        <img src={refund} alt="refund" />
                        {plan.travel.refundable}
                      </div>
                      <div>
                        <img src={screenshot} alt="class" />
                        {plan.travel.class}
                      </div>
                    </div>
                    <div></div>
                  </div>
                  <div style={{fontWeight: '600', color: '#2F80ED'}}>
                    {plan.travel.date}
                  </div>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '90%'
                  }}>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                      <div>
                        <img 
                          src={plan.travel.icon} 
                          style={{width: '70px', height: 'auto'}} 
                          alt="airline"
                        />
                      </div>
                      <div>
                        <div>{plan.travel.airline}</div>
                        <div style={{color: '#777777'}}>{plan.travel.pnr}</div>
                        <div style={{
                          color: '#777777',
                          fontWeight: '300',
                          fontSize: '12px'
                        }}>
                          <img style={{width: '20px'}} src={travel2} alt="checkin" />
                          {plan.travel.carryon} Check In
                        </div>
                        <div style={{
                          color: '#777777',
                          fontWeight: '300',
                          fontSize: '12px'
                        }}>
                          <img style={{width: '20px'}} src={travel1} alt="carryon" />
                          {plan.travel.checkin} Carry On
                        </div>
                      </div>
                    </div>
                    <div>
                      <div style={{fontWeight: '600'}}>
                        {plan.travel.departureTime}, {plan.travel.date}
                      </div>
                      <div style={{fontWeight: '400'}}>
                        {plan.travel.from}-{plan.travel.fromcode}
                      </div>
                      <div style={{fontWeight: '300'}}>
                        {plan.travel.fromair}
                      </div>
                    </div>
                    <div>
                      <div style={{textAlign: 'center'}}>
                        {plan.travel.duration}
                      </div>
                      <div style={{display: 'flex', flexDirection: 'row'}}>
                        <div>
                          <img 
                            src={pln1} 
                            style={{width: '30px', height: 'auto'}} 
                            alt="departure"
                          />
                        </div>
                        <div className='blue-line'></div>
                        <div>
                          <img 
                            src={pln2} 
                            style={{width: '30px', height: 'auto'}} 
                            alt="arrival"
                          />
                        </div>
                      </div>
                      <div style={{textAlign: 'center'}}>Non-stop</div>
                    </div>
                    <div>
                      <div style={{fontWeight: '600'}}>
                        {plan.travel.arrivalTime}, {plan.travel.date}
                      </div>
                      <div style={{fontWeight: '400'}}>
                        {plan.travel.to}-{plan.travel.tocode}
                      </div>
                      <div style={{fontWeight: '300'}}>
                        {plan.travel.toair}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const FilterHotel = ({ onClose }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <div className="customize-hotel-modal">
      <div>
      <form onSubmit={handleSubmit}>

        <div className="form-group-filter">
          <div>Hotel Type:</div>
          <input type="radio" id="economyHotel" name="hotelType" value="economy" />
          <label htmlFor="economyHotel">Economy</label><br />
          <input type="radio" id="standardHotel" name="hotelType" value="standard" />
          <label htmlFor="standardHotel">Standard</label><br />
          <input type="radio" id="luxuryHotel" name="hotelType" value="luxury" />
          <label htmlFor="luxuryHotel">Luxury</label>
        </div>

        <div className="form-group-filter">
          <label>Area:</label><br />
          <input type="checkbox" id="anyArea" name="area" value="any" />
          <label htmlFor="anyArea">Any</label><br />
          <input type="checkbox" id="nearMainAttraction" name="area" value="near-main-attraction" />
          <label htmlFor="nearMainAttraction">Near Main Attraction</label><br />
          <input type="checkbox" id="chinaTown" name="area" value="china-town" />
          <label htmlFor="chinaTown">China Town</label><br />
          <input type="checkbox" id="anotherArea" name="area" value="another-area" />
          <label htmlFor="anotherArea">Another Area</label>
        </div>

        </form>
      </div>
    </div>
  );
};

const ActivityCell = ({ activity }) => {
  const [isPopupOpen, setIsPopupOpen] = React.useState(false);
  const [selectedActivity, setSelectedActivity] = React.useState(null);

  const togglePopup = () => setIsPopupOpen(!isPopupOpen);

  const {
    type,
    start_time,
    end_time,
    source,
    destination,
    detail,
  } = activity;

  // Example activity options with price
  const activityOptions = [
    { name: 'Activity Name 1', price: 100 },
    { name: 'Activity Name 2', price: 150 },
    { name: 'Activity Name 3', price: 200 },
    { name: 'Activity Name 4', price: 250 }
  ];

  // If user selected an activity, show that instead of default
  const displayText = selectedActivity
    ? selectedActivity.name
    : (detail?.name ? detail.name : "Add Activity");

  return (
    <div className="activity-cell">
      <div className="activity-content">
        <span className="activity-text">{displayText}</span>
      </div>

      {displayText === "Add Activity" && (
        <button className="activity-action" onClick={togglePopup}>
          + Add Activity
        </button>
      )}

      {isPopupOpen && (
        <div className="popup-overlay" onClick={togglePopup}>
          <div className="popup-content" onClick={e => e.stopPropagation()}>
            <h3>Change Activity</h3>
            <div className="search-bar">
              <input type="text" placeholder="Search Preferred Activity" />
              <button>→</button>
            </div>
            <div className="activity-list">
              {activityOptions.map((opt, idx) => (
                <div
                  key={idx}
                  className="activity-item"
                  style={{
                    cursor: 'pointer',
                    background: selectedActivity?.name === opt.name ? '#f0f0f0' : undefined
                  }}
                  onClick={() => {
                    setSelectedActivity(opt);
                    setIsPopupOpen(false);
                  }}
                >
                  {opt.name}
                  <div>Price: ₹{opt.price}</div>
                </div>
              ))}
            </div>
            <button onClick={togglePopup}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DayWisePlan;
